<style scoped>
    .foot {
        padding-top: 20px;
        margin-top: 20px;
    }
</style>
<template>
    <div style="padding: 20px 0;">
        <div style="font-size: 20px;padding: 0 20px;">
            <div>选择要使用的模板</div>
        </div>
        <div style="border-top: 1px solid #f1f1f1;margin-top: 20px;padding-bottom: 40px;">
            <div style="padding: 10px;">
                <!-- <Select v-model="query.shouhuojigouStr" style="width:140px" @on-change="page.current=1;loadData();" clearable filterable placeholder="收货机构">
                    <Option v-for="(item,index) in shouhuojigous" :key="index" :value="item.name" :label="item.name">
                        <div>{{item.name}}</div>
                        <div style="color:#ccc;font-size: 10px;" class="nowrap">{{item.code}}</div>
                    </Option>
                </Select> -->
                <Input v-model="query.keywords" icon="ios-search" placeholder="输入名称或编号查询..." style="width: 240px;" @on-enter="keywordsChanged">
                </Input>
                <!-- <Button type="primary" @click="showConditions">按条件筛选</Button> -->
                <Tag v-if="usedKeywords" closable @on-close="clearKeywords" style="height: 32px;line-height: 32px;margin: 0;">
                    搜索：{{usedKeywords}}</Tag>
            </div>
            <div v-if="shengchanmobans.length">
                <Table :columns="columns1" :loading="loading" :data="shengchanmobans" @on-select="itemSelected" @on-select-cancel="itemSelectedCancel" @on-select-all="allSelected" @on-select-all-cancel="allSelectedCancel"></Table>
                <div style="float:right">
                    <Page size="small" placement="top" :total="total" :current="page.current" :page-size="page.size" @on-change="pageChanged" show-total style="padding: 16px;"></Page>
                </div>
            </div>
            <div v-if="!shengchanmobans.length" class="center" style="color: #aaa;min-height: 200px;">暂无数据</div>
        </div>
    </div>
</template>
<script>
    export default {
        props: {
            current: Array,
            jigou: Object,
        },
        data() {
            return {
                loading: false,
                query: {
                    keywords: '',
                    init: true,
                },
                usedKeywords: '',
                page: {
                    current: 1,
                    size: 5,
                },
                total: 0,
                shengchanmobans: [],
                columns1: [{
                        title: '模板编号',
                        key: 'code',
                        minWidth: 180,
                    },
                    {
                        title: '模板名称',
                        minWidth: 100,
                        render: (h, params) => {
                            return h('div', params.row.name)
                        }
                    },
                    {
                        title: '操作',
                        width: 180,
                        align: 'center',
                        fixed: 'right',
                        render: (h, params) => {
                            let that = this
                            let item = params.row
                            let ops = []
                            let op1 = h('div', {
                                class: 'hover',
                                style: {
                                    color: '#20bf64',
                                },
                                on: {
                                    'click': function(e) {
                                        that.selection = item
                                        that.$emit('shengchanmobanSelected', that.selection)
                                        e.stopPropagation()
                                    }
                                }
                            }, '确定')
                            ops.push(op1)
                            return h('div', { class: 'center' }, ops)
                        }
                    },
                ],
                yaohuojigous: [],
            }
        },
        mounted() {
            this.loadData()
        },
        methods: {
            clearKeywords() {
                this.query.keywords = ''
                this.usedKeywords = ''
                this.loadData()
            },
            keywordsChanged() {
                this.usedKeywords = this.query.keywords
                this.page.current = 1
                this.loadData()
            },
            pageChanged(value) {
                this.page.current = value
                this.loadData()
            },
            loadData() {
                let that = this
                that.loading = true
                that.$api.post('/web/main/shengchanmobanselector/load', {
                    jigouId: this.jigou ? this.jigou._id : null,
                    query: this.query,
                    page: this.page,
                    fields: {
                        _id: 1,
                        code: 1,
                        name: 1,
                        'jiagongpins.wupin._id': 1,
                        'jiagongpins.wupin.name': 1,
                        'jiagongpins.wupin.code': 1,
                    }
                }).then(res => {
                    that.loading = false
                    if (that.query.init) {
                        that.query.init = false
                        // that.shouhuojigous = res.data.shouhuojigous
                    }
                    that.total = res.data.total
                    that.usedKeywords = that.query.keywords
                    let shengchanmobans = res.data.shengchanmobans
                    // for (let shengchanmoban of shengchanmobans) {}
                    that.shengchanmobans = shengchanmobans
                }, () => {
                    that.loading = false
                })
            },
            search() {
                this.loadData()
            },
            cancel() {
                this.$emit('cancel')
            },
        },
    };
</script>


// WEBPACK FOOTER //
// src/components/common/ShengchanmobanSelector.vue?c6f622f2